import styled from 'styled-components';

const SimpleHeaderContainer = styled.div`
  background: var(--white);
  display: flex;
  height: 55px;
  justify-content: center;
  align-items: center;

  img {
    width: 200px;
  }

  .simple-header--link {
    height: max-content;
    padding: 8px 15px;
    text-align: center;
    width: max-content;

    &:hover {
      cursor: pointer;
      background: var(--grey-1);
      border-radius: 4px;
    }
  }
`;

export { SimpleHeaderContainer };
